<script lang="ts">
    import { categoryPathMap } from "../../store"

    import ProductList from "./ProductList.svelte"
    import ProductListVertical from "./ProductListVertical.svelte"

    export let title1 = ""
    export let title2 = ""
    export let moreLinkText = ""
    export let moreLinkURL = ""
    export let path: string = null
    export let filter: any = null
    export let limit = 10
    export let sort = "popular"
    export let direction: "horizontal" | "vertical" = "horizontal"

    let count = 10

    let sectionWidth: number
    let innerWidth: number

    $: marginRight = innerWidth > 768 ? (innerWidth - sectionWidth) / -2 + 15 : undefined
</script>

<svelte:window bind:innerWidth />

<section bind:clientWidth="{sectionWidth}">
    <div class="subline">{title1}</div>
    <h2 class="h2_nooffset">{title2}</h2>
    <div
        class:products_scroll="{direction == 'horizontal'}"
        style="{marginRight && direction == 'horizontal' ? 'margin-right: ' + marginRight + 'px' : ''}"
    >
        <div class="products_inner" style="{direction == 'horizontal' ? 'width:' + 300 * count + 'px;' : ''}">
            {#if (typeof path === "string" && $categoryPathMap[path]) || filter}
                {#if direction === "horizontal"}
                    <ProductList
                        filter="{typeof path === 'string'
                            ? {
                                  categories: {
                                      $in: $categoryPathMap[path].allIds,
                                  },
                                  popular: { $gt: 0 },
                              }
                            : filter}"
                        hideMore
                        {limit}
                        {sort}
                        bind:currentCount="{count}"
                    />
                {:else}
                    <ProductListVertical
                        filter="{typeof path === 'string'
                            ? {
                                  categories: {
                                      $in: $categoryPathMap[path].allIds,
                                  },
                                  popular: { $gt: 0 },
                              }
                            : filter}"
                        {sort}
                        bind:currentCount="{count}"
                    />
                {/if}
            {/if}
        </div>
    </div>

    {#if moreLinkText && moreLinkURL}
        <div class="center_btn">
            <a href="{moreLinkURL}" class="btn btn-secondary">{moreLinkText}</a>
        </div>
    {/if}
</section>

<style lang="less">
    @import "../../css/variables.less";
    /*.products {
        .flex();
        flex-wrap: wrap;
        margin: 0 -20px 40px -20px;
        overflow: hidden;
    }*/

    .products_scroll {
        min-height: 400px;
        padding: 0;
        margin: 0 0px 20px 0px;
        position: relative;
        overflow-x: scroll;
        @media @tablet {
            margin: 0 -20px 20px -20px;
            padding: 0 20px;
        }
        :global .products {
            flex-wrap: nowrap;
            overflow: hidden;
            margin: 0 0px 20px -20px;
            @media @tablet {
                margin: 0 -20px 20px -20px;
            }
            .product {
                width: 300px;
            }
        }
        &::-webkit-scrollbar {
            height: 14px;
            .border-radius(5px);
        }
        &::-webkit-scrollbar-track {
            background: var(--comp--scrollbar-track--background);
            height: 5px;
            .border-radius(5px);
        }
        &::-webkit-scrollbar-thumb {
            background: var(--comp--scrollbar-thumb--background);
            .border-radius(5px);
        }
        &::-webkit-scrollbar-thumb:hover {
            background: var(--comp--scrollbar-thumb--background-hover);
        }
        &:-webkit-scrollbar-button:start:decrement,
        &:-webkit-scrollbar-button:end:increment {
            display: block;
            height: 5px;
        }
    }
</style>
